import styled from 'styled-components';

export const TableStyled = styled.div`
  .ant-table-container {
    .ant-table-thead > tr > th {
      white-space: nowrap;
    }
    .ant-table-thead > tr > th.ant-table-cell-fix-right {
      right: 0px;
    }
    .ant-table-column-sorters {
      padding: 0;
    }
    .ant-table-tbody > tr > td {
      /* white-space: nowrap; */
    }
    .ant-table-body {
      overflow-y: auto !important;
      overflow-x: auto !important;
    }
    .ant-table-expanded-row-fixed {
      padding: 0;
      margin: 0;
    }
    .ant-table-thead > tr > th {
      padding: 10px 8px;
    }
    /* 头部背景色 */
    th {
      font-size: 14px;
      /* color: ${(props) => props.theme[props.brand].table.thHeadColor}; */
      background: ${(props) => props.theme[props.brand].table.thHeadBckColor};
    }
    td {
      font-size: 14px;
      /* height: 76px; */
      /* line-height: 76px; */
      padding: 0 8px !important;
    }
    .ant-table-tbody > tr > td {
      /* line-height: 67px; */
      height: 67px;
      vertical-align: middle;
    }
    /* 头部选中后复选框背景色 */
    th .ant-checkbox-checked .ant-checkbox-inner {
      /* background: blue; */
      /* background: ${(props) =>
        props.theme[props.brand].table.thHeadColor}; */
    }
    /* 选中后背景色 */
    .ant-table-tbody > tr.ant-table-row-selected > td {
      background: ${(props) => props.theme[props.brand].table.rowColor};
    }
    /* 复选框选中时设置复选框border，背景色 */
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${(props) => props.theme[props.brand].table.bgColor};
      border-color: ${(props) => props.theme[props.brand].table.bgColor};
    }
    /* 复选框悬浮时设置复选框border */
    .ant-checkbox-checked::after {
      border: 1px solid ${(props) => props.theme[props.brand].table.bgColor};
    }
    /* 复选框悬浮时设置复选框border */
    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: ${(props) => props.theme[props.brand].table.bgColor};
    }
    /* 半选时第一个复选框中间颜色 */
    .ant-checkbox-indeterminate .ant-checkbox-inner::after {
      background-color: ${(props) => props.theme[props.brand].table.bgColor};
    }
    /* row悬浮时设置背景色 */
    .ant-table-tbody > tr.ant-table-row:hover > td {
      background-color: ${(props) =>
        props.theme[props.brand].table.rowHoverColor};
    }
    /* 悬浮row设置复选框border 会影响复选框悬浮时的复选框border
    .ant-table-tbody > tr.ant-table-row:hover > td:nth-of-type(1) .ant-checkbox-inner {
      border: 1px solid ${(props) => props.theme[props.brand].table.rowColor};
    } */
    .zebra-highlight {
      background: #f3f6f6;
    }
  }
  /* 选中页数颜色 */
  .ant-pagination-item-active,
  .ant-pagination-item:hover {
    border-color: ${(props) => props.theme[props.brand].table.bgColor};

    a {
      color: ${(props) => props.theme[props.brand].table.bgColor};
    }
  }
  /* 选页数悬浮时border */
  .ant-pagination-item-active:focus,
  .ant-pagination-item-active:hover {
    border: 1px solid ${(props) => props.theme[props.brand].table.bgColor};
  }
  /* 悬浮时颜色 */
  .ant-pagination-item:focus a,
  .ant-pagination-item:hover a {
    color: ${(props) => props.theme[props.brand].table.bgColor};
  }
  /* 翻页图标悬浮颜色 */
  .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    color: ${(props) => props.theme[props.brand].table.bgColor};
  }
  /* table切换pageSize悬浮时外框颜色 */
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: ${(props) => props.theme[props.brand].table.bgColor};
    border-right-width: 1px !important;
  }
  /* 切换pageSize下拉选中背景色设置 */
  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    font-weight: 600;
    background-color: ${(props) => props.theme[props.brand].table.rowColor};
  }

  /* 下拉框修饰主题颜色 */
  .ant-pagination-options:focus {
    outline-color: ${(props) =>
      props.theme[props.brand].table.bgColor} !important;
  }
  .ant-pagination-options-size-changer:focus {
    outline-color: ${(props) =>
      props.theme[props.brand].table.bgColor} !important;
  }
  .ant-select-selector:focus {
    outline-color: ${(props) =>
      props.theme[props.brand].table.bgColor} !important;
  }
  .ant-select-focused.ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector {
    box-shadow: 0 0 0 1px
      ${(props) => props.theme[props.brand].table.focusBorderColor};
    transition: all 0.3s cubic-bezier
      ${(props) => props.theme[props.brand].table.bgColor};
  }
  .ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector:focus {
    /* border: 1px solid ${(props) =>
      props.theme[props.brand].table.bgColor}; */
  }
  .ant-select-focused {
    .ant-select-selector {
      border: 1px solid ${(props) => props.theme[props.brand].table.bgColor} !important;
    }
  }
  .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    border-color: ${(props) => props.theme[props.brand].table.bgColor};
  }
  .ant-pagination-item-container .ant-pagination-item-link-icon {
    svg {
      fill: ${(props) => props.theme[props.brand].table.bgColor};
    }
  }
`;
